import fetch from 'isomorphic-fetch';
import * as types from '../constants/ActionTypes.js';
import filtersToApply from '../scripts/FiltersToApply.js';
import * as userService from '../services/userService.js';
import { history } from '../helpers/history.js';

const apiAddress = process.env.REACT_APP_API;

//search key
export const setSearchKey = params => ({ type: types.SET_SEARCH_KEY, params });
export const resetSearchKey = () => ({ type: types.RESET_SEARCH_KEY });

//api address
export const setApiAddress = apiAddress => ({ type: types.SET_API_ADDRESS, apiAddress });
export const resetApiAddress = () => ({ type: types.RESET_API_ADDRESS });

//csv address
export const setCsvAddress = csvAddress => ({ type: types.SET_CSV_ADDRESS, csvAddress });
export const resetCsvAddress = () => ({ type: types.RESET_CSV_ADDRESS });

//simple search results
const requestSimpleSearchResults = () => ({ type: types.REQUEST_SIMPLE_SEARCH_RESULTS });
const receiveSimpleSearchResults = results => ({ type: types.RECEIVE_SIMPLE_SEARCH_RESULTS, results });
const setSimpleSearchResultsTab = name => ({ type: types.SET_SIMPLE_SEARCH_RESULTS_TAB, name });

const setSimpleSearchResultsError = error => ({ type: types.SET_SIMPLE_SEARCH_RESULTS_ERROR, error });
export const simpleSearchWrongQueryError = () => ({ type: types.SIMPLE_SEARCH_WRONG_QUERY_ERROR });

export const setTabNav = (fieldName, options) => ({ type: types.SET_TAB_NAV, fieldName, options });
export const resetTabNav = () => ({ type: types.RESET_TAB_NAV });

export const requestLoadFilterByName = (tabName, fieldName) => ({ type: types.REQUEST_LOAD_FILTER_BY_NAME, tabName, fieldName });
export const receiveLoadFilterByName = (results, tabName, fieldName) => ({ type: types.RECEIVE_LOAD_FILTER_BY_NAME, results, tabName, fieldName });
export const loadFilterByNameError = (error, tabName, fieldName) => ({ type: types.LOAD_FILTER_BY_NAME_ERROR, error, tabName, fieldName });

export const setFilter = (fieldName, id) => ({ type: types.SET_FILTER, fieldName, id });

export const loadFilterByName = (fieldName, key, tabName) => {
	return (dispatch) => {
		dispatch(requestLoadFilterByName(tabName, fieldName));

		const getFacetName = (name) => {
			switch (name) {
				case 'RECORD_PERSON':
					return 'persons';
				case 'AUTHOR':
					return 'authors';
				case 'EVENT_LOCATION':
					return 'places';
				case 'INSTITUTION_LOCATION':
					return 'places';
				default:
					break;
			}
		};

		const getTabName = (name) => {
			switch (name) {
				case 'records':
					return 'records';
				case 'creative-work':
					return 'creative-works';
				case 'event':
					return 'events';
				case 'institution':
					return 'institutions';
				case 'place':
					return 'place';
				default:
					break;
			}
		};

		fetch(key ? `${apiAddress}/api/facet/${getTabName(tabName)}/${getFacetName(fieldName)}/${key}` : `${apiAddress}/api/facet/${getTabName(tabName)}/top/${getFacetName(fieldName)}`)
			.then(response => {
				if (response.status >= 400) {
					throw new Error(response.status);
				}
				return response.json();
			})
			.then(json => dispatch(receiveLoadFilterByName(json, tabName, fieldName)))
			.catch(err => dispatch(loadFilterByNameError(err, tabName, fieldName)));
	};
};

export const loadAllFiltersByName = (fieldName, tabName) => {
	return (dispatch) => {
		dispatch(requestLoadFilterByName(tabName, fieldName));

		const getFacetName = (name) => {
			switch (name) {
				case 'RECORD_PERSON':
					return 'persons';
				case 'AUTHOR':
					return 'authors';
				case 'EVENT_LOCATION':
					return 'places';
				case 'INSTITUTION_LOCATION':
					return 'places';
				default:
					break;
			}
		};

		const getTabName = (name) => {
			switch (name) {
				case 'records':
					return 'records';
				case 'creative-work':
					return 'creative-works';
				case 'event':
					return 'events';
				case 'institution':
					return 'institutions';
				default:
					break;
			}
		};

		fetch(`${apiAddress}/api/facet/${getTabName(tabName)}/all/${getFacetName(fieldName)}`)
			.then(response => {
				if (response.status >= 400) {
					throw new Error(response.status);
				}
				return response.json();
			})
			.then(json => dispatch(receiveLoadFilterByName(json, tabName, fieldName)))
			.catch(err => dispatch(loadFilterByNameError(err, tabName, fieldName)));
	};
};

export const resetHeadingsFilters = () => ({ type: types.RESET_HEADINGS_FILTERS });
export const updateHeadingFilters = (fieldName) => ({ type: types.UPDATE_HEADING_FILTERS, fieldName });
export const updateHeadingFiltersSelect = (value, name) => ({ type: types.UPDATE_HEADING_FILTERS_SELECT, value, name });
export const updateHeadingFiltersSelectRelated = (value, name) => ({ type: types.UPDATE_HEADING_FILTERS_SELECT_RELATED, value, name });

export const applyFilter = fieldName => {
	return (dispatch, getState) => {
		dispatch({
			type: types.APPLY_FILTER,
			fieldName,
			data: filtersToApply(fieldName, getState()),
		});
	};
};

export const removeFilter = (id, name, tab) => ({ type: types.REMOVE_FROM_APPLIED, id, name, tab });
export const cleanAllFilters = () => ({ type: types.CLEAN_ALL_FILTERS });
export const cleanAllFiltersHeadings = () => ({ type: types.CLEAN_ALL_FILTERS_HEADINGS });
export const resetFilters = () => ({ type: types.RESET_FILTERS });
export const resetApplyFilter = () => ({ type: types.RESET_APPLY_FILTER });

export const receiveExpandTree = (data, id) => ({ type: types.EXPAND_TREE, data, id });

export const expandTree = id => {
	return (dispatch) => {
		fetch(`${apiAddress}/heading/get/${id}`)
			.then(response => {
				if (response.status >= 400) {
					throw new Error(response.status);
				}
				return response.json();
			})
			.then(json => dispatch(receiveExpandTree(json, id)))
			.catch(err => dispatch(setSimpleSearchResultsError(err)));
	};
};

export const fetchSimpleSearchResults = query => {
	return (dispatch, getState) => {
		const lang = getState().language.currentLanguage;
		if (query.key !== getState().search.searchParams.key && !getState().simpleSearchResults.isBlocked) {
			dispatch(cleanAllFilters());
		}
		const currentApiAdress = query.isHeadingsDetails 
            ? (`${apiAddress}/heading-details/search/${encodeURIComponent(query.key)}/${query.area}${query.tab ? `:${query.tab}` : ''}${query.filters}/PARAMS:ITEMS_PER_PAGE=${query.ipp},PAGE_NO=${query.page}${query.sorting ? `,SORTING=${query.sorting}` : ''},LANG=${lang}`)
			: ( query.isAdvancedSearchResults 
                ? (`${apiAddress}/adv-search/${encodeURIComponent(query.key)}${query.filters}/${query.area}${query.tab ? `:${query.tab}` : ''}/PARAMS:ITEMS_PER_PAGE=${query.ipp},PAGE_NO=${query.page}${query.sorting ? `,SORTING=${query.sorting}` : ''},LANG=${lang}`)
				: (`${apiAddress}/search/${encodeURIComponent(query.key)}/${query.area}${query.tab ? `:${query.tab}` : ''}${query.filters}/PARAMS:ITEMS_PER_PAGE=${query.ipp},PAGE_NO=${query.page}${query.sorting ? `,SORTING=${query.sorting}` : ''},LANG=${lang}`));
		const currentCsvAdress = `${apiAddress}/csv/${encodeURIComponent(query.key)}/${query.area}${query.tab ? `:${query.tab}` : ''}${query.filters}/PARAMS:ITEMS_PER_PAGE=${query.ipp},PAGE_NO=${query.page}${query.sorting ? `,SORTING=${query.sorting}` : ''},LANG=${lang}`;

		dispatch(setApiAddress(currentApiAdress));
		dispatch(setCsvAddress(currentCsvAdress));

		dispatch(setSearchKey(query.isAdvancedSearchResults ? { ...query, key: `${encodeURIComponent(query.key)}${query.filters}` } : query));
		dispatch(setSimpleSearchResultsTab(query.area));
		dispatch(requestSimpleSearchResults());

		fetch(`${currentApiAdress}`, {
			headers: {
				'Accept-Language': 'pl-PL,pl;q=0.9,en-US;q=0.8,en;q=0.7,fr-FR;q=0.6',
				'Content-Language': lang
			},
		})
			.then(response => {
				if (response.status >= 400) {
					throw new Error(response.status);
				}
				return response.json();
			})
			.then(json => {                
                return dispatch(receiveSimpleSearchResults(json))
            })
			.catch(err => dispatch(setSimpleSearchResultsError(err)));
	};
};

export const isFieldsOpen = isOpened => ({ type: types.IS_FIELDS_OPEN, isOpened });

export const setIsBlocked = val => ({ type: types.SET_IS_BLOCKED, val });
export const resetIsBlocked = () => ({ type: types.RESET_IS_BLOCKED });

//result page
const requestResult = () => ({ type: types.REQUEST_RESULT });
const receiveResult = data => ({ type: types.RECEIVE_RESULT, data });
const setResultError = error => ({ type: types.SET_RESULT_ERROR, error });

export const resetResultData = () => ({ type: types.RESET_RESULT_DATA });

export const fetchResult = (id, type) => {
	return (dispatch, getState) => {
		dispatch(requestResult());
		const lang = getState().language.currentLanguage;

		const currentApiAdress = `${apiAddress}/${type}/get/${id}?lang=${lang}`;

		dispatch(setApiAddress(currentApiAdress));

		fetch(`${currentApiAdress}`)
			.then(response => {
				if (response.status >= 400) {
					throw new Error(response.status);
				}

				return response.json();
			})
			.then(json => {
				dispatch(receiveResult(json))
			})
			.catch(err => dispatch(setResultError(err)));
	};
};

//advanced search
export const setAdvancedSearchTab = name => ({ type: types.SET_ADVANCED_SEARCH_TAB, name });
const receiveTabData = (data, activeTab) => ({ type: types.RECEIVE_TAB_DATA, data });
const requestTabData = () => ({ type: types.REQUEST_TAB_DATA });
const setTabError = () => ({ type: types.SET_TAB_ERROR });

export const getActiveTabData = name => {
	return (dispatch, getState) => {
		dispatch(requestTabData());

		fetch(`${apiAddress}/adv-search-keys/${name.toUpperCase()}`)
			.then(response => {
				if (response.status >= 400) {
					throw new Error(response.status);
				}
				return response.json();
			})
			.then(json => dispatch(receiveTabData(json)))
			.catch(err => dispatch(setTabError(err)));
	};
};

//languages
export const setLang = lang => ({ type: types.SET_CURRENT_LANGUAGE, lang });

export const receiveDictionary = data => ({ type: types.RECEIVE_DICTIONARY, data });

export const getDictionary = (name, clang) => {
	return (dispatch, getState) => {

		fetch(`${apiAddress}/dictionaries-all`)
			.then(response => {
				if (response.status >= 400) {
					throw new Error(response.status);
				}
				return response.json();
			})
			.then(json => dispatch(receiveDictionary(json)));
	};
};

//font
export const setFontSize = size => ({ type: types.SET_FONT_SIZE, size });

//contrast
export const setContrast = contrast => ({ type: types.SET_CONTRAST, contrast });

//about-characteristics
const receiveCharacterData = data => ({ type: types.RECEIVE_CHARACTER_DATA, data });
const setCharacterError = () => ({ type: types.SET_CHARACTER_ERROR });
const requestCharacterData = () => ({ type: types.REQUEST_CHARACTER_DATA });

export const getCharacterAbout = (name, clang) => {
	return (dispatch, getState) => {
		dispatch(requestCharacterData());

		const getPageNum = (name) => {
			switch (name) {
				case 'records':
					return clang === 'en' ? '2053' : '1954';
				case 'files':
					return clang === 'en' ? '2051' : '1952';
				default:
					break;
			}
		};

		fetch(`https://pbl2.dlibra.psnc.pl/wp-json/wp/v2/pages/${getPageNum(name)}`)
			.then(response => {
				if (response.status >= 400) {
					throw new Error(response.status);
				}
				return response.json();
			})
			.then(json => dispatch(receiveCharacterData(json)))
			.catch(err => dispatch(setCharacterError(err)));
	};
};

//characteristics-headings
const requestHeadingsAbout = () => ({ type: types.REQUEST_HEADINGS_ABOUT });
const receiveHeadingsAbout = data => ({ type: types.RECEIVE_HEADINGS_ABOUT, data });
const setCharacterHeadingsAboutError = () => ({ type: types.SET_CHARACTER_HEADINGS_ABOUT_ERROR });

export const getHeadingsAbout = (clang) => {
	return (dispatch, getState) => {
		dispatch(requestHeadingsAbout());

		const getLangNum = (lang) => {
			switch (lang) {
				case 'pl':
					return '1958';
				case 'en':
					return '2056';
				default:
					break;
			}
		};

		fetch(`https://pbl2.dlibra.psnc.pl/wp-json/wp/v2/pages/${getLangNum(clang)}`)
			.then(response => {
				if (response.status >= 400) {
					throw new Error(response.status);
				}
				return response.json();
			})
			.then(json => dispatch(receiveHeadingsAbout(json)))
			.catch(err => dispatch(setCharacterHeadingsAboutError(err)));
	};
};

const requestHeadingsRoots = () => ({ type: types.REQUEST_HEADINGS_ROOTS });
const receiveHeadingsRoots = data => ({ type: types.RECEIVE_HEADINGS_ROOTS, data });
const setCharacterHeadingsRootsError = () => ({ type: types.SET_CHARACTER_HEADINGS_ROOTS_ERROR });

export const getHeadingsRoots = () => {
	return (dispatch, getState) => {
		dispatch(requestHeadingsRoots());

		fetch(`${apiAddress}/headings-domain/get/all`)
			.then(response => {
				if (response.status >= 400) {
					throw new Error(response.status);
				}
				return response.json();
			})
			.then(json => dispatch(receiveHeadingsRoots(json)))
			.catch(err => dispatch(setCharacterHeadingsRootsError(err)));
	};
};

const receiveHeadingChildren = (data, name) => ({ type: types.RECEIVE_HEADINGS_CHILDREN, data, name });
const requestHeadingChildren = (name) => ({ type: types.REQUEST_HEADINGS_CHILDREN, name });
const setCharacterHeadingChildrenError = (err, name) => ({ type: types.SET_CHARACTER_HEADING_CHILDREN_ERROR, err, name });

export const getHeadingChildren = (name) => {
	return (dispatch, getState) => {
		dispatch(requestHeadingChildren(name));
		fetch(`${apiAddress}/headings/get/${name}`)
			.then(response => {
				if (response.status >= 400) {
					throw new Error(response.status);
				}
				return response.json();
			})
			.then(json => dispatch(receiveHeadingChildren(json, name)))
			.catch(err => dispatch(setCharacterHeadingChildrenError(err, name)));
	};
};

export const getHeadingChildrenReversed = (name, heading) => {
	return (dispatch, getState) => {
		dispatch(requestHeadingChildren(name));
		fetch(`${apiAddress}/heading/path/get/${heading}`)
			.then(response => {
				if (response.status >= 400) {
					throw new Error(response.status);
				}
				return response.json();
			})
			.then(json => dispatch(receiveHeadingChildren(json, name)))
			.catch(err => dispatch(setCharacterHeadingChildrenError(err, name)));
	};
};

const receiveFieldChildren = (data) => ({ type: types.RECEIVE_FIELD_CHILDREN, data });

export const getFieldChildren = (index) => {
    console.log("getFieldChildren:", index);
	return (dispatch, getState) => {
		fetch(`${apiAddress}/heading/get/${index}`)
			.then(response => {
				if (response.status >= 400) {
					throw new Error(response.status);
				}
				return response.json();
			})
			.then(json => dispatch(receiveFieldChildren(json)))
			.catch(err => dispatch(setCharacterHeadingChildrenError(err)));
	};
};

const receiveHeadingsTitleResults = (data) => ({ type: types.RECEIVE_HEADINGS_TITLE_RESULTS, data });
const requestHeadingsTitleResults = (name) => ({ type: types.REQUEST_HEADINGS_TITLE_RESULTS, name });
const setHeadingsTitleResultsError = (err) => ({ type: types.SET_CHARACTER_HEADING_TITLE_RESULTS_ERROR, err });

const setHeadingsSearchKey = (key) => ({ type: types.SET_HEADINGS_SEARCH_KEY, key });
export const resetHeadingsSearchKey = () => ({ type: types.RESET_HEADINGS_SEARCH_KEY });

export const fetchHeadingsTitleResults = (key) => {
	return (dispatch, getState) => {
		dispatch(setHeadingsSearchKey(key));
		dispatch(requestHeadingsTitleResults());

		fetch(`${apiAddress}/headings/search/${key}`)
			.then(response => {
				if (response.status >= 400) {
					throw new Error(response.status);
				}
				return response.json();
			})
			.then(json => dispatch(receiveHeadingsTitleResults(json)))
			.catch(err => dispatch(setHeadingsTitleResultsError(err)));
	};
};

// headings-details

const receiveHeadingDetails = (data) => ({ type: types.RECEIVE_HEADING_DETAILS, data });
const requestHeadingDetails = () => ({ type: types.REQUEST_HEADING_DETAILS });
const setHeadingDetailsError = (err) => ({ type: types.SET_HEADING_DETAILS_ERROR, err });

export const getHeadingDetails = (index) => {
	return (dispatch, getState) => {
		dispatch(requestHeadingDetails());

		fetch(`${apiAddress}/heading/get/${index}`)
			.then(response => {
				if (response.status >= 400) {
					throw new Error(response.status);
				}
				return response.json();
			})
			.then(json => {
				dispatch(receiveHeadingDetails(json))
			})
			.catch(err => dispatch(setHeadingDetailsError(err)));
	};
};

//main-page

const receiveHeaderMenu = (data) => ({ type: types.RECEIVE_HEADER_MENU, data });

export const getHeaderMenu = (clang) => {
	const getLangNum = (lang) => {
		switch (lang) {
			case 'pl':
			default:
				return '41';
			case 'en':
				return '43';
		}
	};

	return (dispatch, getState) => {
		fetch(`https://pbl2.dlibra.psnc.pl/wp-json/wp-api-menus/v2/menus/${getLangNum(clang)}`)
			.then(response => {
				return response.json();
			})
			.then(json => dispatch(receiveHeaderMenu(json)));
	};
};

const receiveFooterMenu = (data) => ({ type: types.RECEIVE_FOOTER_MENU, data });

export const getFooterMenu = (clang) => {
	const getLangNum = (lang) => {
		switch (lang) {
			case 'pl':
			default:
				return '2058';
			case 'en':
				return '2060';
		}
	};

	return (dispatch, getState) => {
		fetch(`https://pbl2.dlibra.psnc.pl/wp-json/wp/v2/pages/${getLangNum(clang)}`)
			.then(response => {
				return response.json();
			})
			.then(json => dispatch(receiveFooterMenu(json)));
	};
};

const receiveFooterSitemap = (data) => ({ type: types.RECEIVE_FOOTER_SITEMAP, data });

export const getFooterSitemap = (clang) => {
	const getLangNum = (lang) => {
		switch (lang) {
			case 'pl':
			default:
				return '44';
			case 'en':
				return '45';
		}
	};

	return (dispatch, getState) => {
		fetch(`https://pbl2.dlibra.psnc.pl/wp-json/wp-api-menus/v2/menus/${getLangNum(clang)}`)
			.then(response => {
				return response.json();
			})
			.then(json => dispatch(receiveFooterSitemap(json)));
	};
};

const receiveHeadingsInfo = (data) => ({ type: types.RECEIVE_HEADINGS_INFO, data });

export const getMainPageHeadingsInfo = () => {
	return (dispatch, getState) => {
		fetch(`${apiAddress}/headings-domain/get/all`)
			.then(response => {
				return response.json();
			})
			.then(json => dispatch(receiveHeadingsInfo(json)));
	};
};

const receiveNewsMainPage = (data) => ({ type: types.RECEIVE_NEWS_MAIN_PAGE, data });
const requestNewsMainPage = () => ({ type: types.REQUEST_NEWS_MAIN_PAGE });
const setNewsMainPageError = () => ({ type: types.SET_NEWS_MAIN_PAGE_ERROR });

export const getNewsMainPage = (clang) => {
	return (dispatch, getState) => {
		dispatch(requestNewsMainPage());

		fetch(`https://pbl2.dlibra.psnc.pl/wp-json/wp/v2/posts?lang=pl`)
			.then(response => {
				if (response.status >= 400) {
					throw new Error(response.status);
				}
				return response.json();
			})
			.then(json => dispatch(receiveNewsMainPage(json)))
			.catch(err => dispatch(setNewsMainPageError(err)));
	};
};

const receivePosMainPage = (data) => ({ type: types.RECEIVE_POS_MAIN_PAGE, data });
const requestPosMainPage = () => ({ type: types.REQUEST_POS_MAIN_PAGE });
const setPosMainPage = () => ({ type: types.SET_POS_MAIN_PAGE_ERROR });

export const getPosMainPage = (clang) => {
	const getLangNum = (lang) => {
		switch (lang) {
			case 'pl':
			default:
				return '1960';
			// case 'en':
			//   return '45';
		}
	};

	return (dispatch, getState) => {
		dispatch(requestPosMainPage());
		fetch(`https://pbl2.dlibra.psnc.pl/wp-json/wp/v2/pages/${getLangNum(clang)}`)
			.then(response => {
				if (response.status >= 400) {
					throw new Error(response.status);
				}
				return response.json();
			})
			.then(json => dispatch(receivePosMainPage(json)))
			.catch(err => dispatch(setPosMainPage(err)));
	};
};

const receivePblNumber = (data) => ({ type: types.RECEIVE_PBL_NUMBER, data });
const requestPblNumber = () => ({ type: types.REQUEST_PBL_NUMBER });
const setPblNumberError = () => ({ type: types.SET_PBL_NUMBER_ERROR });

export const getPblNumber = (clang) => {
	return (dispatch, getState) => {
		dispatch(requestPblNumber());

		fetch(`${apiAddress}/statistics`)
			.then(response => {
				if (response.status >= 400) {
					throw new Error(response.status);
				}
				return response.json();
			})
			.then(json => dispatch(receivePblNumber(json)))
			.catch(err => dispatch(setPblNumberError(err)));
	};
}

const receiveWhatInPbl = (data) => ({ type: types.RECEIVE_WHAT_IN_PBL, data });
const requestWhatInPbl = () => ({ type: types.REQUEST_WHAT_IN_PBL });
const setWhatInPblError = () => ({ type: types.SET_WHAT_IN_PBL_ERROR });

export const getWhatInPbl = (clang) => {
	const getLangNum = (lang) => {
		switch (lang) {
			case 'pl':
			default:
				return '1929';
			case 'en':
				return '1989';
		}
	};

	return (dispatch, getState) => {
		dispatch(requestWhatInPbl());

		fetch(`https://pbl2.dlibra.psnc.pl//wp-json/wp/v2/pages?parent=${getLangNum(clang)}`)
			.then(response => {
				if (response.status >= 400) {
					throw new Error(response.status);
				}
				return response.json();
			})
			.then(json => dispatch(receiveWhatInPbl(json)))
			.catch(err => dispatch(setWhatInPblError(err)));
	};
};

//about-pbl

const receiveAboutPblSubpage = (data) => ({ type: types.RECEIVE_ABOUT_PBL_SUBPAGE, data });
const requestAboutPblSubpage = () => ({ type: types.REQUEST_ABOUT_PBL_SUBPAGE });
const setAboutPblSubpageError = () => ({ type: types.SET_ABOUT_PBL_SUBPAGE_ERROR });

export const getAboutPblSubpage = (id, lang) => {
	const getLangNum = (id, lang) => {
		switch (id) {
			case 'what-is':
			default:
				return lang === 'en' ? '/1993' : '/1933';
			case 'how-search':
				return lang === 'en' ? '/1991' : '/1931';
			case 'what-in':
				return lang === 'en' ? '/1989' : '/1929';
			case 'examples':
				return lang === 'en' ? '?parent=1989' : '?parent=1929';
			case 'how-create':
				return lang === 'en' ? '/1987' : '/1927';
			case 'source':
				return lang === 'en' ? '/1985' : '/1925';
			case 'conditions':
				return lang === 'en' ? '/1983' : '/1923';
			case 'team':
				return lang === 'en' ? '/1981' : '/1921';
			case 'contact':
				return lang === 'en' ? '/1979' : '/1918';
			case 'privacy-policy':
				return lang === 'en' ? '/2308' : '/2306';
			case 'api-docs':
				return lang === 'en' ? '/3241' : '/3239';
			case 'accessibility':
				return lang === 'en' ? '/3362' : '/3359';
			case 'publications-about-pbl':
				return lang === 'en' ? '/4137' : '/3806';
			case 'pbl-in-knowledge-graph':
				return lang === 'en' ? '/4263' : '/4255';
		}
	};

	return (dispatch) => {
		dispatch(requestAboutPblSubpage());
		fetch(`https://pbl2.dlibra.psnc.pl/wp-json/wp/v2/pages${getLangNum(id, lang)}`)
			.then(response => {
				if (response.status >= 400) {
					throw new Error(response.status);
				}
				return response.json();
			})
			.then(json => dispatch(receiveAboutPblSubpage(json)))
			.catch(err => dispatch(setAboutPblSubpageError(err)));
	};
};


//about-pbl examples
const requestAboutPblExamples = () => ({ type: types.REQUEST_ABOUT_PBL_EXAMPLES });
const receiveAboutPblExamples = (data) => ({ type: types.RECEIVE_ABOUT_PBL_EXAMPLES, data });
const setAboutPblExamplesError = () => ({ type: types.SET_ABOUT_PBL_EXAMPLES_ERROR });

export const getAboutPblExamples = (clang) => {
	return (dispatch, getState) => {
		dispatch(requestAboutPblExamples());

		const getLangNum = (lang) => {
			switch (lang) {
				case 'pl':
					return '3188';
				case 'en':
					return '3190';
				default:
					break;
			}
		};

		fetch(`https://pbl2.dlibra.psnc.pl/wp-json/wp/v2/pages/${getLangNum(clang)}`)
			.then(response => {
				if (response.status >= 400) {
					throw new Error(response.status);
				}
				return response.json();
			})
			.then(json => dispatch(receiveAboutPblExamples(json)))
			.catch(err => dispatch(setAboutPblExamplesError(err)));
	};
};

//news

const receiveNewsSubpage = (data) => ({ type: types.RECEIVE_NEWS_SUBPAGE, data });
const requestNewsSubpage = () => ({ type: types.REQUEST_NEWS_SUBPAGE });
const setNewsSubpageError = () => ({ type: types.SET_NEWS_SUBPAGE_ERROR });

export const getNewsSubpage = (id, lang) => {
	const getPage = (id, lang) => {
		switch (id) {
			case 'all':
			default:
				return `https://pbl2.dlibra.psnc.pl/wp-json/wp/v2/posts?lang=pl&per_page=100`;
			case 'events':
				return lang === 'pl' ?
					`https://pbl2.dlibra.psnc.pl/wp-json/wp/v2/posts?categories=35&per_page=100`
					: `https://pbl2.dlibra.psnc.pl/wp-json/wp/v2/posts?categories=60&per_page=100`;
			case 'conferences':
				return lang === 'pl' ?
					`https://pbl2.dlibra.psnc.pl/wp-json/wp/v2/posts?categories=66&per_page=100`
					: `https://pbl2.dlibra.psnc.pl/wp-json/wp/v2/posts?categories=76&per_page=100`;
			case 'publications':
				return lang === 'pl' ?
					`https://pbl2.dlibra.psnc.pl/wp-json/wp/v2/posts?categories=70&per_page=100`
					: `https://pbl2.dlibra.psnc.pl/wp-json/wp/v2/posts?categories=74&per_page=100`;
			case 'from-life':
				return lang === 'pl' ?
					`https://pbl2.dlibra.psnc.pl/wp-json/wp/v2/posts?categories=68&per_page=100`
					: `https://pbl2.dlibra.psnc.pl/wp-json/wp/v2/posts?categories=72&per_page=100`;
			case 'projects':
				return lang === 'pl' ?
					`https://pbl2.dlibra.psnc.pl/wp-json/wp/v2/posts?categories=79&per_page=100`
					: `https://pbl2.dlibra.psnc.pl/wp-json/wp/v2/posts?categories=81&per_page=100`;
		}
	};

	return (dispatch) => {
		dispatch(requestNewsSubpage());
		fetch(`${getPage(id, lang)}`)
			.then(response => {
				if (response.status >= 400) {
					throw new Error(response.status);
				}
				return response.json();
			})
			.then(json => dispatch(receiveNewsSubpage(json)))
			.catch(err => dispatch(setNewsSubpageError(err)));
	};
};

//news-category

const receiveNewsCategory = (data) => ({ type: types.RECEIVE_NEWS_CATEGORY, data });
const requestNewsCategory = () => ({ type: types.REQUEST_NEWS_CATEGORY });
const setNewsCategoryError = () => ({ type: types.SET_NEWS_CATEGORY_ERROR });

export const getNewsSubpageCategory = (id, lang) => {
	const getPage = (id, lang) => {
		switch (id) {
			case 'all':
			default:
				return lang === 'pl' ?
					`https://pbl2.dlibra.psnc.pl/wp-json/wp/v2/categories/1`
					: `https://pbl2.dlibra.psnc.pl/wp-json/wp/v2/categories/11`;
			case 'events':
				return lang === 'pl' ?
					`https://pbl2.dlibra.psnc.pl/wp-json/wp/v2/categories/35`
					: `https://pbl2.dlibra.psnc.pl/wp-json/wp/v2/categories/60`;
			case 'conferences':
				return lang === 'pl' ?
					`https://pbl2.dlibra.psnc.pl/wp-json/wp/v2/categories/66`
					: `https://pbl2.dlibra.psnc.pl/wp-json/wp/v2/categories/76`;
			case 'publications':
				return lang === 'pl' ?
					`https://pbl2.dlibra.psnc.pl/wp-json/wp/v2/categories/70`
					: `https://pbl2.dlibra.psnc.pl/wp-json/wp/v2/categories/74`;
			case 'from-life':
				return lang === 'pl' ?
					`https://pbl2.dlibra.psnc.pl/wp-json/wp/v2/categories/68`
					: `https://pbl2.dlibra.psnc.pl/wp-json/wp/v2/categories/72`;
			case 'projects':
				return lang === 'pl' ?
					`https://pbl2.dlibra.psnc.pl/wp-json/wp/v2/categories/79`
					: `https://pbl2.dlibra.psnc.pl/wp-json/wp/v2/categories/81`;
		}
	};

	return (dispatch) => {
		dispatch(requestNewsCategory());
		fetch(`${getPage(id, lang)}`)
			.then(response => {
				if (response.status >= 400) {
					throw new Error(response.status);
				}
				return response.json();
			})
			.then(json => dispatch(receiveNewsCategory(json)))
			.catch(err => dispatch(setNewsCategoryError(err)));
	};
};

//news-item

const receiveNewsItem = (data) => ({ type: types.RECEIVE_NEWS_ITEM, data });
const requestNewsItem = () => ({ type: types.REQUEST_NEWS_ITEM });
const setNewsItemError = () => ({ type: types.SET_NEWS_ITEM_ERROR });

export const getNewsItem = (id) => {
	return (dispatch) => {
		dispatch(requestNewsItem());
		fetch(`https://pbl2.dlibra.psnc.pl/wp-json/wp/v2/posts/${id}`)
			.then(response => {
				if (response.status >= 400) {
					throw new Error(response.status);
				}
				return response.json();
			})
			.then(json => dispatch(receiveNewsItem(json)))
			.catch(err => dispatch(setNewsItemError(err)));
	};
};

//collections

const receiveCollections = (data) => ({ type: types.RECEIVE_COLLECTIONS, data });
const requestCollections = () => ({ type: types.REQUEST_COLLECTIONS });
const setCollectionsError = () => ({ type: types.SET_COLLECTIONS_ERROR });

export const getCollections = (clang) => {
	const getLangNum = (lang) => {
		switch (lang) {
			case 'pl':
			default:
				return '1947';
			case 'en':
				return '2018';
		}
	};

	return (dispatch) => {
		dispatch(requestCollections());

		fetch(`https://pbl2.dlibra.psnc.pl//wp-json/wp/v2/pages?parent=${getLangNum(clang)}`)
			.then(response => {
				if (response.status >= 400) {
					throw new Error(response.status);
				}
				return response.json();
			})
			.then(json => dispatch(receiveCollections(json)))
			.catch(err => dispatch(setCollectionsError(err)));
	};
};

//collections-about

const receiveCollectionsAbout = (data) => ({ type: types.RECEIVE_COLLECTIONS_ABOUT, data });
const requestCollectionsAbout = () => ({ type: types.REQUEST_COLLECTIONS_ABOUT });
const setCollectionsAboutError = () => ({ type: types.SET_COLLECTIONS_ABOUT_ERROR });

export const getCollectionsAbout = (clang) => {
	const getLangNum = (lang) => {
		switch (lang) {
			case 'pl':
			default:
				return '1945';
			case 'en':
				return '1977';
		}
	};

	return (dispatch) => {
		dispatch(requestCollectionsAbout());

		fetch(`https://pbl2.dlibra.psnc.pl//wp-json/wp/v2/pages/${getLangNum(clang)}`)
			.then(response => {
				if (response.status >= 400) {
					throw new Error(response.status);
				}
				return response.json();
			})
			.then(json => dispatch(receiveCollectionsAbout(json)))
			.catch(err => dispatch(setCollectionsAboutError(err)));
	};
};

export const getCollectionAbout = (id) => {
	return (dispatch) => {
		dispatch(requestCollectionsAbout());

		fetch(`https://pbl2.dlibra.psnc.pl//wp-json/wp/v2/pages/${id}`)
			.then(response => {
				if (response.status >= 400) {
					throw new Error(response.status);
				}
				return response.json();
			})
			.then(json => dispatch(receiveCollectionsAbout(json)))
			.catch(err => dispatch(setCollectionsAboutError(err)));
	};
};


// alerts

// const alertActionsSuccess = (message) =>  ({ type: types.SUCCESS, message });
const alertActionsError = (message) => ({ type: types.ERROR, message });
export const alertActionsClear = () => ({ type: types.CLEAR });

// authentication

export const login = (username, password) => {
	return dispatch => {
		dispatch(request({ username }));

		userService.login(username, password)
			.then(
				user => {
					dispatch(success(user));
					history.goBack();
				},
				error => {
					dispatch(failure(error.toString()));
					dispatch(alertActionsError('error'));
				}
			);
	};

	function request(user) { return { type: types.LOGIN_REQUEST, user } }
	function success(user) { return { type: types.LOGIN_SUCCESS, user } }
	function failure(error) { return { type: types.LOGIN_FAILURE, error } }
};

export const logout = () => {
	userService.logout();
	return { type: types.LOGOUT };
};



// WEBPACK FOOTER //
// ./src/actions/index.js